module.exports = __webpack_public_path__ + "img/product3.4706bf01.png";